import { Box, Link } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import LogoBesse from '../../ressources/images/besse-immobilier-construction.jpg';
import LogoFooter from '../../ressources/images/logo_vertuloo_blanc.png';
import Libelle from '../../_i18n/fr.json';
import styles from './styles';

const Footer: React.FC = () => {
  return (
    <Box component="footer" sx={styles} className="footer">
      <div className="footerLogo">
        <img src={LogoFooter} className="footerLogoImg" height={40} alt="" />{' '}
        <div className="footerLogoBesse">
          {' '}
          <img src={LogoBesse} height={60} alt="" />
        </div>
      </div>
      <ul className="footerLiens">
        <li className="footerLien">
          <Link
            component={RouterLink}
            className="footerLien"
            {...({ to: '/mentions-legales' } as any)}
          >
            {Libelle.footer.mentionsLegales.libelle}
          </Link>
        </li>
        <li className="footerLien">
          <Link
            component={RouterLink}
            className="footerLien"
            {...({ to: '/protection-des-donnees' } as any)}
          >
            {Libelle.footer.protectionDonneesPersonnelles.libelle}
          </Link>
        </li>
      </ul>
    </Box>
  );
};

export default Footer;
